<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.mobile_app.change_dietitian.change_dietitian` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <p v-if="!changingDietitianSuccessful">
                {{ `app.mobile_app.change_dietitian.change_dietitian_description` | trans }}
              </p>
              <v-btn v-if="!changingDietitianSuccessful" :disabled="loading" :loading="loading" color="primary"
                     type="submit"
                     @click="changeDietitian">{{ `app.mobile_app.change_dietitian.confirm` | trans }}
              </v-btn>
              <v-alert :value="changingDietitianSuccessful" type="success">
                {{ `app.mobile_app.change_dietitian.changing_dietitian_successful` | trans }}
              </v-alert>
              <div v-if="changingDietitianSuccessful">
                <mobile-app-download :app-store-link="appStoreLink" :google-play-link="googlePlayLink"/>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a :href="routes.logout">{{ `app.logout` | trans }}</a>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
import {trans} from "../../app";

export default {
  props: {
    routes: Object,
    appStoreLink: String,
    googlePlayLink: String,
    alreadyAccepted: Boolean,
  },
  data() {
    return {
      loading: false,
      password: "",
      changingDietitianSuccessful: false,
    };
  },
  mounted() {
    this.changingDietitianSuccessful = this.alreadyAccepted;
  },
  methods: {
    changeDietitian() {
      this.loading = true;
      axios.post(this.routes.change_dietitian)
          .then(() => {
            this.loading = false;
            this.changingDietitianSuccessful = true;
          }).catch(() => {
        this.loading = false;
        this.changingDietitianSuccessful = false;
        this.$toast.error(trans('app.mobile_app.change_dietitian.changing_dietitian_failed'));
      })
    }
  }
}
</script>
